import { getPathFromState as getPathFromStateDefault } from '@react-navigation/native'
import { dynamicRoutes } from '../../static/Routes'

const { REACT_APP_ENDPOINT = '' } = process.env

const BUSINESS_TAG = 'business'

const Linking = {
  prefixes: ['http://localhost:3000/', 'localhost://'],
  config: {
    initialRouteName: dynamicRoutes.jiopay,
    screens: {
      rsil: {
        path: `${REACT_APP_ENDPOINT}/${dynamicRoutes.rsil}`,
      },
      jiopay: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}`,
      },
      'widen-presence': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.widenPresence}`,
      },
      'mitigate-risk': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.mitigateRisk}`,
      },
      'simplified-experience': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.simplifiedExperience}`,
      },
      'increase-conversion': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.increaseConversion}`,
      },
      'mobile-checkout': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/paymentgateway/${dynamicRoutes.checkout}`,
      },
      repeat: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/paymentgateway/${dynamicRoutes.repeat}`,
      },
      collect: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/paymentgateway/${dynamicRoutes.collect}`,
      },
      campaign: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/paymentgateway/${dynamicRoutes.campaign}`,
      },
      products: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.products}`,
      },
      direct: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/paymentgateway/${dynamicRoutes.direct}`,
      },
      vault: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/paymentgateway/${dynamicRoutes.vault}`,
      },
      console: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/paymentgateway/${dynamicRoutes.console}`,
      },
      oneqr: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/paymentgateway/${dynamicRoutes.oneqr}`,
      },
      contact: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.contact}`,
      },
      voicebox: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.voicebox}`,
      },
      'voicebox-qr': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.voiceboxQr}`,
      },
      'packagingbox-qr': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.packagingBoxQr}`,
      },
      'about-us': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.aboutUs}`,
      },
      'help-center': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.helpCenter}`,
      },
      'privacy-policy': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.privacyPolicy}`,
      },
      'terms-conditions': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.termsNcondition}`,
      },
      'jio-pay-business': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.jioPayBusiness}`,
      },
      'investor-relation': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.investorRelation}`,
      },
      'on-boarding-and-kyc-policy': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.onBoardingAndKyc}`,
      },
      'grievance-redressal-policy': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.grievance}`,
      },
      'complaint-resolution-escalation-matrix': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.compliantResolutionNescalationMatrix}`,
      },
      '1qrfaqs': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.QRFAQ}`,
      },
      paymentgateway: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/paymentgateway`,
      },
      pointofsale: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/pointofsale`,
      },
      upi: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/upi`,
      },
      biller: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/biller`,
      },
      'jio-pay-consumers': {
        path: `${REACT_APP_ENDPOINT}/consumers`,
      },
      'partner-program': {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/partner-program`,
      },
      [dynamicRoutes.billpayTermsAndCond]: {
        path: `${REACT_APP_ENDPOINT}/${BUSINESS_TAG}/${dynamicRoutes.billpayTermsAndCond}`,
      },
    },
  },
  getPathFromState: (state: any, options: any) => {
    let path = getPathFromStateDefault(state, options)
    path = decodeURIComponent(path)
    return path
  },
}

export { Linking }
